<template>
  <div :class="{ drawer: true }" v-if="value">
    <div class="drawer-mask"></div>
    <div class="drawer-wrap" @click="doClose">
      <div class="bottom">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'my-drawer',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    doClose (even) {
      const className = event.target.getAttribute('class')
      if (className && className.indexOf('drawer-wrap') > -1) this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.drawer {
  .drawer-mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(55,55,55,.6);
    z-index: 1000;
    animation: mask-animat .8s 1;
    @keyframes mask-animat {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  }
  .drawer-wrap {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    outline: 0;
    .bottom {
      width: 100%;
      background: #fff;
      position: fixed;
      bottom: 0;
      overflow: auto;
      padding: 8px 0;
      animation: bottom-animat 1s 1;
      @keyframes bottom-animat {
        from {
          max-height: 0;
        }
        to {
          max-height: 90%;
        }
      }
    }
  }
}
</style>